import { Page } from "@tfg/ui"

export const SupplierContactsWrapper = () => {
  return <Page title="Contacts" />
}
